var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path8, _path9, _path10, _path11, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _circle, _circle2, _circle3, _circle4, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 184,
    viewBox: "0 0 219 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.515 38C216.015 54 241.515 118 182.515 139L20.0147 126C-0.985849 118 -26.4844 4 65.0148 0C98.5154 0 107.015 19 107.015 19L132.515 23C160.015 35 164.015 28 186.515 38Z",
    fill: "#52A0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5879 81C17.5879 78.7909 19.3788 77 21.5879 77H61.0165C63.2256 77 65.0165 78.7909 65.0165 81V143H17.5879V81Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4442 143V81C64.4442 78.7909 62.6533 77 60.4442 77H21.0156C18.8065 77 17.0156 78.7909 17.0156 81V143",
    stroke: "#00244B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0156 83C55.0156 81.8954 54.1202 81 53.0156 81H23.0156C21.9111 81 21.0156 81.8954 21.0156 83V143H55.0156V83Z",
    fill: "#EEF6FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.0156,
    y: 87,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0156,
    y: 101,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0156,
    y: 115,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0156,
    y: 129,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0156,
    y: 87,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0156,
    y: 101,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0156,
    y: 115,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0156,
    y: 129,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#03366D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.016 49C137.016 46.7909 138.806 45 141.016 45H184.016C186.225 45 188.016 46.7909 188.016 49V142H137.016V49Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.016 142V49C187.016 46.7909 185.225 45 183.016 45H140.016C137.806 45 136.016 46.7909 136.016 49V142",
    stroke: "#00244B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.016 50C183.016 48.8954 182.12 48 181.016 48H139.016C137.911 48 137.016 48.8954 137.016 50V142H183.016V50Z",
    fill: "#EEF6FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 143.016,
    y: 56,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 143.016,
    y: 79,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 143.016,
    y: 102,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 163.016,
    y: 56,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 163.016,
    y: 79,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 163.016,
    y: 102,
    width: 9,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0156 7C57.0156 4.79086 58.8065 3 61.0156 3H136.016C138.225 3 140.016 4.79086 140.016 7V150H57.0156V7Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.016 150V7C139.016 4.79086 137.225 3 135.016 3H60.0156C57.8065 3 56.0156 4.79086 56.0156 7V150",
    stroke: "#00244B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0156 12C57.0156 9.79086 58.8065 8 61.0156 8H132.016C134.225 8 136.016 9.79086 136.016 12V150H57.0156V12Z",
    fill: "#EEF6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.016 150V7C139.016 4.79086 137.225 3 135.016 3H60.0156C57.8065 3 56.0156 4.79086 56.0156 7V150",
    stroke: "#00244B",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0156,
    y: 19,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0156,
    y: 45,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0156,
    y: 71,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0156,
    y: 97,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0156,
    y: 123,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 104.016,
    y: 19,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 104.016,
    y: 45,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 104.016,
    y: 97,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 104.016,
    y: 71,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 104.016,
    y: 123,
    width: 17,
    height: 17,
    rx: 2,
    fill: "#03366D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 124.429,
    y: 115.732,
    width: 14,
    height: 98,
    rx: 4,
    transform: "rotate(-47.485 124.429 115.732)",
    fill: "#EEF6FF",
    stroke: "#00244B",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118.016,
    cy: 96,
    r: 53,
    fill: "#EEF6FF",
    stroke: "#00244B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.016,
    cy: 96,
    r: 37,
    fill: "white",
    stroke: "#00244B",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.516,
    cy: 94.5,
    r: 35.5,
    fill: "#C8E2FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.016,
    cy: 96,
    r: 37,
    stroke: "#00244B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.352 99.876C114.352 98.9373 114.513 98.116 114.836 97.412C115.158 96.708 115.51 96.1653 115.892 95.784C116.273 95.4027 116.904 94.8013 117.784 93.98C117.872 93.892 118.253 93.5547 118.928 92.968C119.602 92.3813 120.116 91.692 120.468 90.9C120.849 90.108 121.04 89.2573 121.04 88.348C121.04 86.8227 120.512 85.5467 119.456 84.52C118.429 83.464 117.153 82.936 115.628 82.936C114.102 82.936 112.797 83.4787 111.712 84.564C110.656 85.62 110.128 86.9253 110.128 88.48V90.064L108.016 89.976V88.48C108.016 87.1013 108.353 85.84 109.028 84.696C109.702 83.552 110.626 82.6573 111.8 82.012C112.973 81.3373 114.264 81 115.672 81C117.08 81 118.356 81.3227 119.5 81.968C120.644 82.584 121.538 83.4493 122.184 84.564C122.829 85.6787 123.152 86.9107 123.152 88.26C123.152 89.404 122.976 90.3867 122.624 91.208C122.272 92 121.876 92.6307 121.436 93.1C121.025 93.5693 120.409 94.1853 119.588 94.948C119.441 95.0947 119.045 95.4613 118.4 96.048C117.754 96.6053 117.256 97.2067 116.904 97.852C116.581 98.4973 116.42 99.2013 116.42 99.964V102.12H114.352V99.876ZM113.692 107.4C113.692 106.901 113.868 106.491 114.22 106.168C114.572 105.816 114.997 105.64 115.496 105.64C115.994 105.64 116.405 105.816 116.728 106.168C117.08 106.491 117.256 106.901 117.256 107.4C117.256 107.899 117.08 108.324 116.728 108.676C116.376 109.028 115.965 109.204 115.496 109.204C114.997 109.204 114.572 109.028 114.22 108.676C113.868 108.324 113.692 107.899 113.692 107.4Z",
    fill: "#00244B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAddress);
export default __webpack_public_path__ + "static/media/empty-address.c33d869bcf463e580d92b941f8d42786.svg";
export { ForwardRef as ReactComponent };